module.exports = __webpack_public_path__ + "img/@work_kiwoom_list.d579f9e6.png";